import { render } from "./Nibble.vue?vue&type=template&id=dbcd0894"
import script from "./Nibble.vue?vue&type=script&lang=js"
export * from "./Nibble.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "dbcd0894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbcd0894', script)) {
    api.reload('dbcd0894', script)
  }
  
  module.hot.accept("./Nibble.vue?vue&type=template&id=dbcd0894", () => {
    api.rerender('dbcd0894', render)
  })

}

script.__file = "src/icons/components/logos/Nibble.vue"

export default script